import { render } from "./pageExplain.vue?vue&type=template&id=4dc06a5a&scoped=true"
import script from "./pageExplain.vue?vue&type=script&lang=js"
export * from "./pageExplain.vue?vue&type=script&lang=js"

import "./pageExplain.vue?vue&type=style&index=0&id=4dc06a5a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc06a5a"]])

export default __exports__